import { Injectable } from '@angular/core';
import { User } from '../Models/User';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _loggedInUser: User | undefined;

  get loggedInUser(): User | undefined {
    return this._loggedInUser;
  }

  setLoggedInUser(user: User | undefined): void {
    this._loggedInUser = user;
  }

  clearUser(): void {
    this._loggedInUser = undefined;
  }
}
